import {
  alarmModelToCreateGraphql,
  createAlarmMutation,
} from '@akin-home/alarms/frontend';
import {
  alertModelToCreateGraphql,
  createAlertMutation,
} from '@akin-home/alerts/frontend';
import { CalendarItemType } from '@akin-home/amplify';
import {
  createEventMutation,
  eventModelToCreateGrapqhl,
} from '@akin-home/events/frontend';
import {
  createMealMutation,
  mealModelToCreateGraphql,
} from '@akin-home/meals/frontend';
import { CalendarItemUnion } from '../types';

/** This funciton can delete any calendar item */
export const createCalendarItem = async <T extends CalendarItemUnion>(
  item: T
) => {
  switch (item.type) {
    case CalendarItemType.Event:
      return createEventMutation({
        input: await eventModelToCreateGrapqhl(item),
      });
    case CalendarItemType.Alert:
      return createAlertMutation({
        input: await alertModelToCreateGraphql(item),
      });
    case CalendarItemType.Alarm:
      return createAlarmMutation({
        input: await alarmModelToCreateGraphql(item),
      });
    case CalendarItemType.Meal:
      return createMealMutation({
        input: await mealModelToCreateGraphql(item),
      });
    default:
      return undefined;
  }
};
